module.exports = __webpack_public_path__ + "static/media/feature_4_5.12bf1640.jpg";